import React, { useState } from "react";
import "./home.css";
import Navbar from "./components/Navbar";
import RecentDocuments from "./components/RecentDocuments";
import YourDocuments from "./components/YourDocuments";
import { useNavigate } from "react-router-dom";

export default function SavedDocumentsPage() {
    const [debouncedQuery, setDebouncedQuery] = useState("");
    const navigate = useNavigate();

    const handleBackToHome = () => {
        navigate("/home");
    };

    return (
        <>
            <div className="navbar_homepage">
                <Navbar showBackToHome onBackToHome={handleBackToHome} />
                <RecentDocuments setDebouncedQuery={setDebouncedQuery} />
            </div>
            <div className="yourDocuments_homepage">
                <YourDocuments debouncedQuery={debouncedQuery} />
            </div>
        </>
    );
}
